module.exports = __webpack_public_path__ + "img/ics_f_thumb-neutral.24395027.svg";